import React from 'react';
import BoxBody from 'components/BoxBody';
import Image from 'components/Image';
import Link from 'components/Link';
import LinkConstants from 'constants/LinkConstants';
import RemindCoachingLogo from 'assets/images/coaching/coaching_logo.svg';
import Row from 'components/Row';
import Text from 'components/Text';

export default function CoachingIsolatedViewHeader() {
  return (
    <Row size="small">
      <BoxBody size="small">
        <Text align="center">
          <Link href={LinkConstants.COACHING}>
            <Image src={RemindCoachingLogo} width="180" />
          </Link>
        </Text>
      </BoxBody>
    </Row>
  );
}
